var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7978 0.237757C12.0807 0.540309 12.0648 1.01491 11.7622 1.29782L4.5435 8.04782C4.25522 8.31737 3.80737 8.3174 3.51907 8.04788L0.237818 4.98038C-0.0647649 4.6975 -0.0807439 4.2229 0.202128 3.92032C0.484999 3.61773 0.959604 3.60176 1.26219 3.88463L4.03119 6.47325L10.7378 0.202185C11.0403 -0.0807207 11.5149 -0.0647943 11.7978 0.237757Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.9934bee6d97e02b75f20641996c521d5.svg";
export { ForwardRef as ReactComponent };